import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 20000,
  withCredentials: true, // send the vdv_session cookie on every call
});

export async function fetchExperiences({ country, city, category, lang = "en" } = {}) {
  const params = {};
  if (country) params.country = country;
  if (city) params.city = city;
  if (category) params.category = category;
  params.lang = lang;
  const { data } = await api.get("/experiences", { params });
  return data;
}

export async function fetchExperience(slug, { lang = "en" } = {}) {
  const { data } = await api.get(`/experiences/${slug}`, { params: { lang } });
  return data;
}

export async function fetchCountries({ lang = "en" } = {}) {
  const { data } = await api.get("/countries", { params: { lang } });
  return data;
}

export async function fetchCities({ country, lang = "en" } = {}) {
  const params = { lang };
  if (country) params.country = country;
  const { data } = await api.get("/cities", { params });
  return data;
}

export async function fetchCategories({ lang = "en" } = {}) {
  const { data } = await api.get("/categories", { params: { lang } });
  return data;
}

/** Resolve a backend-static path to a full URL hosted by the frontend domain. */
export function staticUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return path; // /static/... served by CRA from /public/static
}
